import { useEffect, useState } from "react";

/** State persisted as JSON under `key`. Unreadable or blocked storage falls back to `initial`. */
export function useLocalStorage<T>(key: string, initial: T) {
  const [value, setValue] = useState<T>(() => {
    try {
      const raw = window.localStorage.getItem(key);
      return raw === null ? initial : (JSON.parse(raw) as T);
    } catch {
      return initial;
    }
  });
  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // Private mode or a full quota: keep the in-memory state.
    }
  }, [key, value]);
  return [value, setValue] as const;
}
